import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

export interface LvcDrawer {
  onToggle: string
  title: string
  open: boolean
}

export class LvcDrawer extends MinzeElement {
  attrs: Attrs = ['title', 'on-toggle', 'open']
  static observedAttributes = ['on-toggle', 'open']

  onCloseButtonClick() {
    this.open = false
    Callback.call(this.onToggle, this.open)
    this.rerender()
  }

  onAttributeChange(name: string, value: any) {
    switch (name) {
      case 'open':
        this.open = !!value
        break
      case 'on-toggle':
        this.onToggle = value ?? ''
        break
    }
  }

  html = () => {
    return `
      <div class="drawer-header ${this.open ? 'open' : ''}" name="toggleDrawer">
        <div class="drawer-title">${this.title}</div>
        <div class="dropdown-button">
          <lvc-chevron-down-icon class="${this.open ? 'up' : 'down'}" width="19.5" height="19.5"></lvc-chevron-down-icon>
        </div>
      </div>
      <div class="drawer-content ${this.open ? 'open' : ''}">
        <slot name="lvc-drawer-trigger"></slot>
        <slot name="lvc-drawer-content"></slot>
      </div>
    `
  }

  css = () => {
    return `
      :host {
        padding: 0px;
        border-bottom: 1px solid rgba(30, 0, 125, 0.30);
        border-top: 1px solid rgba(30, 0, 125, 0.30);
        ${!this.open ? 'border: none;' : ''}
        box-sizing: border-box;
      }
      .drawer-header {
        display: none;
      }

      .dropdown-button{
        display: flex;
        justify-content: flex-end;
      }

      lvc-chevron-down-icon.up {
        transform: rotate(180deg);
        transition: transform 2.2s ease-in-out;
      }
        
      lvc-chevron-down-icon.down {
       transform: rotate(180deg);
        transition: transform 2.2s ease-in-out;
      }

      .drawer-header.open {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0px 10px 0px 8px;
      }

      .drawer-title {
        color: var(--brand-minuit, #1E007D);
        font-variant-numeric: lining-nums tabular-nums;
        font-feature-settings: 'clig' off, 'liga' off;

        /* D/boutons/principal */
        font-family: ${Font.family};
        font-size: 14px;
        font-style: normal;
        font-weight: ${Font.weight.medium};
        line-height: 40px;
      }

      .dropdown-button {
        flex: 0 0 auto;
      }


      [name="lvc-drawer-trigger"] {
        ${this.open ? 'display: none;' : ''}
      }

      [name="lvc-drawer-content"] {
        ${!this.open ? 'display: none;' : ''}
        margin: 16px;
      }

    `
  }

  eventListeners: EventListeners = [
    ['[name="toggleDrawer"]', 'click', this.onCloseButtonClick.bind(this)],
  ]
}
